import React from 'react'

import PlayArrowIcon from '@mui/icons-material/PlayArrow'

import { VideoCardStyle } from '../styles'
import { youtubeEmbed } from '../../utils/youtubeEmbed'
import VideoModal from '../modals/VideoModal'
import ResourceCard from './ResourceCard'
import { openExternal } from '../../utils/safeUrl'

const VideoCard = (props) => {
    const openResource = () => {
        openExternal(props.link)
        return false;
    }

    return (
        <ResourceCard
            Icon={PlayArrowIcon}
            cardStyle={VideoCardStyle}
            modal={<VideoModal {...props} />}
            title={props.title}
            description={props.description}
            thumbnail={youtubeEmbed(props.link)?.posterUrl ?? undefined}
            date={props.pub_date}
            content_tags={props.content_tags}
            medical_specialty_tags={props.medical_specialty_tags}
            is_seminal_work={props.is_seminal_work || props.seminal_work}
            onOpen={openResource}
        />
    )
}

export default VideoCard
